import { getStringHash } from '@/src/utils/getStringHash'

// Tags are also built in modules client components import, and Next sends fetch tags in a response header
// (ASCII only), so this uses a dependency-free ASCII hash instead of Node `crypto`
export const getCacheTag = (id: string, prefix?: string) => {
  const hash = getStringHash(id)

  return prefix ? `${prefix}-${hash}` : hash
}
